"use client";

import ForgotPasswordPage from "@/app/account/ForgotPasswordPage";

export default function ForgotPasswordRoute() {
  return <ForgotPasswordPage />;
}
